/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const bulkDeleteContactsDtoSchema = z.object({
    "contactIds": z.array(z.uuid()).min(1).max(1000).describe("Contacts to act on. Duplicates are handled once.")
    })